<template>
  <button
      class="btn orcaBtn btn-warning"
      style="min-width:200px;background-color:palevioletred;"
      :disabled="adminBusy"
      @click="run"
      type="button"
  >
    <span v-if="!adminBusy">Bypass Finance and close</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
export default {
  name: "AdminDismissAllSitesButton",

  props: {
    companyId: { required: true },
    period:    { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true },
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/dismiss/all?submission_date=${this.period}`;

      await axios.post(url);
      this.$snotify?.success(`All sites for ${this.period} and company ${this.companyId} bypassed and closed!`);
    },

    async run() {
      await this.withAdminLock(this.doAction)();
      await this.success();
    }
  }
};
</script>
